import React, { useState } from 'react';
import AdminVideosTab from './AdminVideosTab';
import AdminUsersTab from './AdminUsersTab';
import '../styles/admin-video-page.css';

type TabType = 'videos' | 'users';

const AdminPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('videos');

  return (
    <div className="avp-container">
      <div className="avp-header">
        <h1 className="avp-title">Admin Panel</h1>
        <div className="avp-tabs">
          <button
            className={`avp-tab ${activeTab === 'videos' ? 'avp-tab-active' : ''}`}
            onClick={() => setActiveTab('videos')}
          >
            Videos
          </button>
          <button
            className={`avp-tab ${activeTab === 'users' ? 'avp-tab-active' : ''}`}
            onClick={() => setActiveTab('users')}
          >
            Users
          </button>
        </div>
      </div>

      <div className="avp-tab-content">
        {activeTab === 'videos' && <AdminVideosTab />}
        {activeTab === 'users' && <AdminUsersTab />}
      </div>
    </div>
  );
};

export default AdminPage;